import app from '@/app';
import templateUrl from './save-button-bar.html';

var component = {
	templateUrl,
	require: {
		form: '^form'
	},
	bindings: {
		soft: '<',
		disabled: '<',
		readonly: '<',
		saving: '<',
		onAccept: '&',
		onReject: '&'
	}
};

app.component('prSaveButtonBar', component);
